/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as RepoDefs from './defs.defs.js'

const $nsid = 'com.atproto.repo.putRecord'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  repo: /*#__PURE__*/ l.string({ format: 'at-identifier' }),
  rkey: /*#__PURE__*/ l.string({ format: 'record-key', maxLength: 512 }),
  record: /*#__PURE__*/ l.lexMap(),
  validate: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  collection: /*#__PURE__*/ l.string({ format: 'nsid' }),
  swapCommit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'cid' }),
  ),
  swapRecord: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.nullable(/*#__PURE__*/ l.string({ format: 'cid' })),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cid: /*#__PURE__*/ l.string({ format: 'cid' }),
  uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
  commit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<RepoDefs.CommitMeta>(
      (() => RepoDefs.commitMeta) as any,
    ),
  ),
  validationStatus: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{ knownValues: ['valid', 'unknown'] }>(),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Write a repository record, creating or updating it as needed. Requires auth, implemented by PDS. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'InvalidSwap',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
